import { lazy } from "react";

const Signin = lazy(() => import("../pages/Auth/Signin"));
const Signup = lazy(() => import("../pages/Auth/Signup"));
const OAuthCallback = lazy(() => import("../pages/Auth/OAuthCallback"));
const EmailVerification = lazy(() => import("../pages/Auth/EmailVerification"));

export const publicRoutes = [
  {
    path: "/signin",
    Component: Signin,
  },
  {
    path: "/register",
    Component: Signup,
  },
  {
    path: "/oauth-callback",
    Component: OAuthCallback,
  },
  {
    path: "/auth/verify-email",
    Component: EmailVerification,
  },
];
